/* unsafe-eval */

/**
 * Globals
 */
import globals from "imports/globals";

/**
 * jQuery
 */
import $ from "cash-dom";

$(document).ready(function () {
    if (globals.debug) console.log("document ready");
    $("html").addClass("document-ready");
});

$(window).on("load", function () {
    if (globals.debug) console.log("window loaded");
    $("html").addClass("window-loaded");
});

$(window).on("resize", function () {
    if (globals.debug) console.log(`window resized to ${window.innerWidth} x ${window.innerHeight}px`);
});

/**
 * Components
 */
import batchLoad from "imports/component-batch-load";
import dynamicVariables from "imports/component-dynamic-variables";
import enter from "imports/component-enter";
import fillProportionally from "imports/component-fill-proportionally";
import fitProportionally from "imports/component-fit-proportionally";
import hero from "imports/component-hero";
import infobox from "imports/component-infobox";
// import lazyLoad from "imports/component-lazy-load";
// import lightbox from "imports/component-lightbox";
import navigation from "imports/component-navigation";
import outro from "imports/component-outro";
import panorama from "imports/component-panorama";
import parallax from "imports/component-parallax";
import preloader from "imports/component-preloader";
import readMore from "imports/component-read-more";
import scrollIndicator from "imports/component-scroll-indicator";
import tabFocus from "imports/component-tab-focus";
import ui from "imports/component-ui";

/**
 * Layouts
 */
// import accordion from "imports/layout-accordion";
import audio from "imports/layout-audio";
// import contactSheet from "imports/layout-contact-sheet";
import draggable from "imports/layout-draggable-slider";
// import horizontalScroll from "imports/layout-horizontal-scroll";
// import hotspot from "imports/layout-hotspot";
import panningImage from "imports/layout-panning-image";
// import scrollableLottie from "imports/layout-scrollable-lottie";
// import scrollableVideo from "imports/layout-scrollable-video";
import slider from "imports/layout-slider";
// import stickyImage from "imports/layout-sticky-image";
import stickyLottie from "imports/layout-sticky-lottie";
// import video from "imports/layout-video";
